<template>
  <div>

    <div class="brand">
      {{ this.$appName }}
    </div>
    <el-menu
        class="main-nav"
        :router="true"
        :default-active="activeRoute"
        mode="vertical"
        @select="handleSelect"
        background-color="#191a23"
        text-color="rgba(255,255,255,0.7)"
        active-text-color="#ffffff">
      <el-menu-item index="/home/index">首页</el-menu-item>
      <el-submenu index="/eorder">
        <template slot="title">国际运单</template>
        <el-menu-item index="/eorder/index">所有运单</el-menu-item>
        <el-menu-item index="/eorder/pickup">待取运单</el-menu-item>
        <el-menu-item index="/eorder/add">新增系统单</el-menu-item>
      </el-submenu>
      <!--<el-submenu index="/concentration">
        <template slot="title">集运管理</template>
        <el-menu-item index="/concentration/apply">打包申请</el-menu-item>
      <el-menu-item index="/concentration/package">包裹管理</el-menu-item>
      </el-submenu>-->
      <el-submenu index="/group">
        <template slot="title">集运拼团</template>
        <el-menu-item index="/group/apply">开团申请</el-menu-item>
        <el-menu-item index="/group/working">进行中</el-menu-item>
        <el-menu-item index="/group/applyDelivery">截团申请</el-menu-item>
        <el-menu-item index="/group/finish">已截团</el-menu-item>
        <!--<el-menu-item index="/group/list">进行中</el-menu-item>
      <el-menu-item index="/group/list">已完成</el-menu-item>-->
      </el-submenu>
      <el-submenu index="/user">
        <template slot="title">客户管理</template>
        <el-menu-item index="/user/index">会员列表</el-menu-item>
        <el-menu-item index="/user/blockUser">黑名单列表</el-menu-item>
      </el-submenu>

      <el-menu-item index="/coupon/index">优惠券管理</el-menu-item>
      <el-menu-item index="/package/index">仓库管理</el-menu-item>
      <el-menu-item index="/container/index">货柜管理</el-menu-item>

      <el-menu-item index="/partner/index">代理商管理</el-menu-item>

      <el-submenu index="/finance">
        <template slot="title">财务统计</template>
        <el-menu-item index="/finance/normal">普通运单与集运入账统计</el-menu-item>
        <el-menu-item index="/finance/groupPayed">集运拼团入账统计</el-menu-item>
        <el-menu-item index="/finance/groupPaying">集运拼团待支付统计</el-menu-item>
        <el-menu-item index="/finance/balanceCharge">充值入账统计</el-menu-item>
        <el-menu-item index="/finance/balanceExpend">充值金消费统计</el-menu-item>
      </el-submenu>
      <el-submenu index="/setting">
        <template slot="title">系统设置</template>
        <el-menu-item index="/setting/fee">运费设置</el-menu-item>
        <el-menu-item index="/setting/staff">员工设置</el-menu-item>
        <el-menu-item index="/setting/guide">新手教程</el-menu-item>
        <el-menu-item index="/setting/about">关于我们</el-menu-item>

      </el-submenu>

    </el-menu>
    <div class="login-out" @click="loginOut()">
      退出系统
    </div>
  </div>
</template>

<script>
import storage from '@/utils/common/storage.js'

export default {
  data() {
    return {
      activeRoute: ''
    }
  },
  mounted() {
    this.activeRoute = this.$route.path

  },
  methods: {
    handleSelect(key, keyPath) {

    },
    loginOut() {
      storage.resetToken()
      window.location.reload();
    }
  }

}
</script>

<style scoped>
.main-nav {
  width: 250px;
}

.brand {
  background-color: #191a23;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #101117;
}

.is-active {
  background-color: #2d8cf0 !important;
  color: #FFFFFF !important;
}

.login-out {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fa3534;
  width: 250px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #FFFFFF;
}
</style>
